import { render, staticRenderFns } from "./AdminCountSettingComponent.vue?vue&type=template&id=b0fd5120&scoped=true&"
import script from "./AdminCountSettingComponent.vue?vue&type=script&lang=js&"
export * from "./AdminCountSettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminCountSettingComponent.vue?vue&type=style&index=0&id=b0fd5120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fd5120",
  null
  
)

export default component.exports